import { render, staticRenderFns } from "./realtime-mock.vue?vue&type=template&id=30a2ed2c"
import script from "./realtime-mock.vue?vue&type=script&lang=js"
export * from "./realtime-mock.vue?vue&type=script&lang=js"
import style0 from "./realtime-mock.vue?vue&type=style&index=0&id=30a2ed2c&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports